// 定义类型常量，默认全部大写
const INCREMENT = 'INCREMENT'
const DECREMENT = 'DECREMENT'
const TOKEN = 'TOKEN'
const USERINFO = 'USERINFO'
const LOGINSTATUS = 'LOGINSTATUS'
const USERROUTER = 'USERROUTER' // 用户路由
const MESSAGE='MESSAGE'  //上传端和管理端 收到的过期/即将过期消息

const ADMINMESSAGE="ADMINMESSAGE"         //管理端收到的回传成功消息

const USERMESSAGE="USERMESSAGE"           //用户端收到的退回/结束/发布消息

const READMESSAGE="READMESSAGE"           //阅读消息

const CLEARMESSAGE="CLEARMESSAGE"        //清空信息
const TEST="TEST"

export default {
    INCREMENT,
    DECREMENT,
    TOKEN,
    USERINFO,
    LOGINSTATUS,
    USERROUTER,
    MESSAGE,
    ADMINMESSAGE,
    USERMESSAGE,
    READMESSAGE,
    TEST,
    CLEARMESSAGE
}


// WEBPACK FOOTER //
// ./src/store/types.js